var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8962 1.5L19.6887 3.70752M19.6887 3.70752L23 7.01879L19.1368 10.8819L15.8256 7.57067M19.6887 3.70752L15.8256 7.57067M11.2891 12.1071C11.859 12.6694 12.3121 13.3389 12.6222 14.0771C12.9323 14.8152 13.0933 15.6074 13.096 16.408C13.0987 17.2087 12.943 18.0019 12.6378 18.7421C12.3327 19.4823 11.8841 20.1549 11.318 20.721C10.7519 21.2871 10.0793 21.7357 9.33913 22.0408C8.59893 22.346 7.80567 22.5017 7.00505 22.499C6.20442 22.4963 5.41222 22.3353 4.67408 22.0252C3.93594 21.7151 3.26644 21.2621 2.70411 20.6921C1.59829 19.5472 0.986398 18.0137 1.00023 16.422C1.01406 14.8303 1.65251 13.3077 2.77806 12.1822C3.90361 11.0566 5.42621 10.4182 7.01792 10.4043C8.60963 10.3905 10.1431 11.0024 11.288 12.1082L11.2891 12.1071ZM11.2891 12.1071L15.8256 7.57067",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDefault);
export default __webpack_public_path__ + "static/media/access_default.a776ed8096e2a4fc93e26b6af1444d90.svg";
export { ForwardRef as ReactComponent };